import { WeeklyDosage } from "@/service/models/common/query-dosage/dosage-choices";
import { FormulationAndRoute } from "@/service/models/common/query-dosage/parts/formulation-and-route";
import { DayTime } from "@/utilities/types/day-time";
import { Duration } from "@/utilities/types/duration";
import { BaseDosageChoiceVM } from "./base-dosage-choice-vm";

export class WeeklyDosageVM extends BaseDosageChoiceVM
{
    public weekDay: number|null = null;
    public time: DayTime|null = null;
    public doseValue: number|null = null;
    public doseUnit: string|null = null;
    public doseInfusionTimeValue: number|null = null;
    public doseInfusionTimeUnit: string|null = null;
    public formulationAndRoute: FormulationAndRoute|null = null;

    public get doseInfusionTime(): Duration|null
    {
        if (this.doseInfusionTimeValue === null || this.doseInfusionTimeUnit === null) {
            return null;
        }

        return Duration.fromUnit(this.doseInfusionTimeValue, this.doseInfusionTimeUnit);
    }

    /**
     * @inheritdoc
     */
    public isValid(): boolean
    {
        return (
            this.weekDay !== null &&
            this.time !== null &&
            this.doseValue !== null &&
            this.doseUnit !== null &&
            this.formulationAndRoute !== null
        );
    }

    /**
     * @inheritdoc
     */
    public getModel(): WeeklyDosage
    {
        if (
            this.weekDay === null ||
            this.time === null ||
            this.doseValue === null ||
            this.doseUnit === null ||
            this.formulationAndRoute === null
        ) {
            throw new Error("Not enough data to populate model");
        }

        return new WeeklyDosage(this.weekDay, this.time, this.doseValue, this.doseUnit, this.doseInfusionTime, this.formulationAndRoute);
    }

    /**
     * @inheritdoc
     */
    public fillFromModel(model: WeeklyDosage): WeeklyDosageVM
    {
        this.formulationAndRoute = model.formulationAndRoute;

        this.weekDay = model.weekDay;
        this.time = model.time;
        this.doseValue = model.doseValue;
        this.doseUnit = model.doseUnit;

        if (model.doseInfusionTime !== null) {
            this.doseInfusionTimeUnit ??= model.doseInfusionTime.getSmallestRoundUnit();
            this.doseInfusionTimeValue = model.doseInfusionTime.inUnit(this.doseInfusionTimeUnit);
        }
        else {
            this.doseInfusionTimeUnit = null;
            this.doseInfusionTimeValue = null;
        }

        return this;
    }
}
